export default "__VITE_ASSET__DUJweyK7__"